interface OpenFileInputSingle {
  multiple: false;
  accept: string;
  onComplete: (file: File) => void | Promise<void>;
}

interface OpenFileInputMultiple {
  multiple: true;
  accept: string;
  onComplete: (files: File[]) => void | Promise<void>;
}

type OpenFileInput = OpenFileInputMultiple | OpenFileInputSingle;

export function useFileInput(inputContainer: HTMLElement = document.body) {
  const open = ({ multiple, accept, onComplete }: OpenFileInput) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = accept;
    input.style.display = "none";
    if (multiple) {
      input.multiple = true;
    }

    inputContainer.appendChild(input);

    async function listener(this: HTMLInputElement, event: Event) {
      const files = this.files;
      if (files) {
        if (multiple) {
          await onComplete(Array.from(files));
        } else {
          await onComplete(files[0]);
        }

        inputContainer.removeChild(input);
      }
    }

    input.addEventListener("change", listener, { once: true });
    input.click();
  };

  return { open };
}
